import { render } from "./Languages.vue?vue&type=template&id=2ab65058&scoped=true"
import script from "./Languages.vue?vue&type=script&lang=ts"
export * from "./Languages.vue?vue&type=script&lang=ts"

import "./Languages.vue?vue&type=style&index=0&id=2ab65058&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2ab65058"

export default script